import { render } from "./washCar.vue?vue&type=template&id=5a9005fa&scoped=true"
import script from "./washCar.vue?vue&type=script&lang=js"
export * from "./washCar.vue?vue&type=script&lang=js"

import "./washCar.vue?vue&type=style&index=0&id=5a9005fa&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9005fa"]])

export default __exports__